/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */

import "./src/styles/style.scss"

export const onRouteUpdate = ({ location, prevLocation }) => {
  console.log('in onRouteUpdate');
  console.log("new pathname", location.pathname);
  console.log("old pathname", prevLocation ? prevLocation.pathname : null);
  //console.log('activatig google ads');
  //var adsbygoogle;
  //(adsbygoogle = window.adsbygoogle || []).push({});
  //console.log({ adsbygoogle });
}

export const onInitialClientRender = () => {
  window.scrollTo(0, 0);
};